export function compareTable() {
    // Position the teal ring around the featured column.
    // (The custom-scrollbar IIFE from the original snippet is gone —
    //  wa-scrollbar handles all of that now.)
    (function () {
        const inner = document.querySelector('.compare-inner');
        if (!inner) return;
        const table = inner.querySelector('.compare-table');
        const featured = inner.querySelector('[data-featured]');
        const ring = inner.querySelector('[data-ring]');
        if (!table || !featured || !ring) return;

        function positionRing() {
            const innerRect = inner.getBoundingClientRect();
            const tableRect = table.getBoundingClientRect();
            const colRect = featured.getBoundingClientRect();
            const padY = 0; // vertical breathing room only — hug the column edges horizontally

            ring.style.left = (colRect.left - innerRect.left) + 'px';
            ring.style.top = (tableRect.top - innerRect.top + padY) + 'px';
            ring.style.width = colRect.width + 'px';
            ring.style.height = (tableRect.height - padY * 2) + 'px';
            ring.classList.add('is-ready');
        }

        // Run now, after the custom element upgrades (layout may shift),
        // after web-fonts settle, and on every window resize.
        positionRing();
        customElements.whenDefined('wa-scrollbar')
            .then(() => requestAnimationFrame(positionRing));
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(positionRing);
        }
        window.addEventListener('resize', positionRing);
    })();
}